/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Selleroffers_Error1Inputs */

const id_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan memuat penawaran. Silakan coba lagi.`)
};

const ms_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat memuat tawaran. Sila cuba lagi.`)
};

const da_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl ved indlæsning af tilbud. Prøv venligst igen.`)
};

const de_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Angebote. Bitte versuchen Sie es erneut.`)
};

const en_us2_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading offers. Please try again.`)
};

const es_es2_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar las ofertas. Por favor, inténtalo de nuevo.`)
};

const es_mx2_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar las ofertas. Por favor, inténtalo de nuevo.`)
};

const fil_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error sa pag-load ng mga offer. Pakisubukan muli.`)
};

const fr_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des offres. Veuillez réessayer.`)
};

const it_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore nel caricamento delle offerte. Riprova.`)
};

const hu_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba az ajánlatok betöltésekor. Kérjük, próbáld újra.`)
};

const nl_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij laden van aanbiedingen. Probeer het opnieuw.`)
};

const no_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil ved lasting av tilbud. Prøv igjen.`)
};

const pl_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd ładowania ofert. Spróbuj ponownie.`)
};

const pt_br2_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading offers. Please try again.`)
};

const pt_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao carregar ofertas. Tente novamente.`)
};

const ro_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare la încărcarea ofertelor. Încearcă din nou.`)
};

const fi_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe ladattaessa tarjouksia. Yritä uudelleen.`)
};

const sv_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel vid inläsning av erbjudanden. Försök igen.`)
};

const vi_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi tải ưu đãi. Vui lòng thử lại.`)
};

const tr_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifler yüklenirken hata oluştu. Lütfen tekrar deneyin.`)
};

const cs_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba při načítání nabídek. Zkuste to prosím znovu.`)
};

const bg_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка при зареждане на офертите. Моля, опитайте отново.`)
};

const ru_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка загрузки предложений. Пожалуйста, попробуйте снова.`)
};

const uk_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка завантаження пропозицій. Спробуйте ще раз.`)
};

const ar_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ في تحميل العروض. حاول مرة أخرى.`)
};

const hi_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र लोड करने में त्रुटि।`)
};

const th_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาดในการโหลดข้อเสนอ กรุณาลองอีกครั้ง`)
};

const ja_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーの読み込みエラー。もう一度お試しください。`)
};

const zh_cn2_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading offers. Please try again.`)
};

const zh_hant1_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading offers. Please try again.`)
};

const ko_components_selleroffers_error1 = /** @type {(inputs: Components_Selleroffers_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading offers. Please try again.`)
};

/**
* | output |
* | --- |
* | "Error loading offers. Please try again." |
*
* @param {Components_Selleroffers_Error1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_selleroffers_error1 = /** @type {((inputs?: Components_Selleroffers_Error1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Selleroffers_Error1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_selleroffers_error1(inputs)
	if (locale === "ms") return ms_components_selleroffers_error1(inputs)
	if (locale === "da") return da_components_selleroffers_error1(inputs)
	if (locale === "de") return de_components_selleroffers_error1(inputs)
	if (locale === "en-US") return en_us2_components_selleroffers_error1(inputs)
	if (locale === "es-ES") return es_es2_components_selleroffers_error1(inputs)
	if (locale === "es-MX") return es_mx2_components_selleroffers_error1(inputs)
	if (locale === "fil") return fil_components_selleroffers_error1(inputs)
	if (locale === "fr") return fr_components_selleroffers_error1(inputs)
	if (locale === "it") return it_components_selleroffers_error1(inputs)
	if (locale === "hu") return hu_components_selleroffers_error1(inputs)
	if (locale === "nl") return nl_components_selleroffers_error1(inputs)
	if (locale === "no") return no_components_selleroffers_error1(inputs)
	if (locale === "pl") return pl_components_selleroffers_error1(inputs)
	if (locale === "pt-BR") return pt_br2_components_selleroffers_error1(inputs)
	if (locale === "pt") return pt_components_selleroffers_error1(inputs)
	if (locale === "ro") return ro_components_selleroffers_error1(inputs)
	if (locale === "fi") return fi_components_selleroffers_error1(inputs)
	if (locale === "sv") return sv_components_selleroffers_error1(inputs)
	if (locale === "vi") return vi_components_selleroffers_error1(inputs)
	if (locale === "tr") return tr_components_selleroffers_error1(inputs)
	if (locale === "cs") return cs_components_selleroffers_error1(inputs)
	if (locale === "bg") return bg_components_selleroffers_error1(inputs)
	if (locale === "ru") return ru_components_selleroffers_error1(inputs)
	if (locale === "uk") return uk_components_selleroffers_error1(inputs)
	if (locale === "ar") return ar_components_selleroffers_error1(inputs)
	if (locale === "hi") return hi_components_selleroffers_error1(inputs)
	if (locale === "th") return th_components_selleroffers_error1(inputs)
	if (locale === "ja") return ja_components_selleroffers_error1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_selleroffers_error1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_selleroffers_error1(inputs)
	return ko_components_selleroffers_error1(inputs)
});
export { components_selleroffers_error1 as "components.sellerOffers.error" }